// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeShortCut_container__jyCRe"};